import {useEffect, useState} from "react";
import {Form, message} from "antd";
import {batch, useDispatch} from "react-redux";
import {
    submitLicence,
    clearNewlyAddedLicence,
    loadDependencies,
    onCompanyChange,
    onProductsChange, removeLicenceElement,
    saveLicence, setLicenceElements, addLicenceElement
} from "../../redux/actions/addLicenceActions";
import {useThemeSelector} from "../../redux/reducers/themeReducer";
import useWindowSize from "../../helpers/useWindowSize";
import breakpoints from "../../constants/breakpoints";
import {useAddLicenceSelector} from "../../redux/reducers/addLicenceReducer";

const useController = ({pathname, history}) => {
    const dispatch = useDispatch();
    const {
        licenceSavePending,
        newLicence,
        allExpiryActions,
        availableCompanies,
        selectedCompany,
        companyHasSoftwareProducts,
        availableSoftwareProducts,
        companyPreviouslyAddedProducts,
        allSoftwareProductElements,
        availableExpiryActions,
        availableSoftwareProductElements,
        addingLicenceForAlreadyAddedSwProductForCompany,
        selectedProduct,
        licenceElements
    } = useAddLicenceSelector();

    const size = useWindowSize();
    const {darkMode, primaryColor} = useThemeSelector();

    const [initialValues, setInitialValues] = useState({});

    const [licenceForm] = Form.useForm();
    const [current, setCurrent] = useState(0);
    const isDeviceSmall = size.width < breakpoints.sm;

    useEffect(() => {
        dispatch(loadDependencies());
    }, []);

    useEffect(() => licenceForm.resetFields(), [initialValues]);

    const addAnotherLicence = () => {
        batch(() => {
            dispatch(clearNewlyAddedLicence());
            setCurrent(0);
            dispatch(setLicenceElements([]));
            licenceForm.resetFields();
        })
    };

    const goToLicences = () => {
        history.push('/licence');
    };

    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const onChange = current => {
        setCurrent(current)
    };

    return {
        onCompanyChange: companyId => dispatch(onCompanyChange(companyId)),
        companySelected: !!selectedCompany,
        selectedProduct,
        addingLicenceForAlreadyAddedSwProductForCompany,
        licenceForm,
        current,
        next,
        prev,
        onChange,
        addLicenceElement: async () => {
            const values = await licenceForm.validateFields();
            dispatch(addLicenceElement(values, () => {
                licenceForm.resetFields();
                licenceForm.setFieldsValue({
                    companyId: values.companyId,
                    softwareProductId: values.softwareProductId,
                    code: values.code
                });
            }));
        },
        submitLicence: async () => {
            const values = await licenceForm.getFieldsValue();
            dispatch(submitLicence(values));
        },
        removeLicenceElement: record => {
            dispatch(removeLicenceElement(record))
        },
        onProductsChange: (selectedProductId, selectedProduct, code) => {
            dispatch(onProductsChange(selectedProductId, selectedProduct, code, formValues => {
                licenceForm.setFieldsValue(formValues);
            }))
        },
        addAnotherLicence,
        goToLicences,
        companyHasSoftwareProducts,
        companyPreviouslyAddedProducts,
        availableSoftwareProducts,
        availableSoftwareProductElements,
        availableCompanies,
        availableExpiryActions,
        initialValues,
        licenceSavePending,
        newLicence,
        licenceElements,
        darkMode,
        primaryColor,
        isDeviceSmall
    }
};

export default useController;